import Vue from "vue";
// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@/assets/globalcss/style.css";
import "./assets/globalcss/style.css";
import "@/assets/globalcss/index.css";
import "@/assets/globalcss/builderpage.css";
import Vuelidate from "vuelidate";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import "vue-popperjs/dist/vue-popper.css";
import { clearStore } from "./utils/tokenCheck";
import { initTracking } from "@/tracking/tracker";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import io from "socket.io-client";
import PosthogPlugin from '../plugins/posthog'
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import { isNativePlatform } from "./utils/platform";
const GOOGLE_OAUTH_CLIENT_ID =
	"127719246868-ghvip7aduug3t64ion8uhncfunb0cond.apps.googleusercontent.com";
const socket = io('https://keynode.hire3x.com', {
	transports: ['websocket']
});

Vue.prototype.$socket = socket;

Vue.component("datetime", Datetime);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.config.productionTip = false;
Vue.use(PosthogPlugin)
Vue.use(DatePicker);
// Vue.use(vue3GoogleLogin, {
// 	clientId: process.env.VUE_APP_CLIENT_ID,
//   });
if (isNativePlatform()) {
	GoogleAuth.initialize({
	  clientId: GOOGLE_OAUTH_CLIENT_ID,
	  scopes: ['profile', 'email'],
	  grantOfflineAccess: true,
	});
  }
function filterControlCharacters(value) {
	return value
		.split("")
		.filter((char) => char.charCodeAt(0) >= 32 || char.charCodeAt(0) === 9)
		.join("");
}

function safeHTML(htmlString) {
	let doc = document.implementation.createHTMLDocument("");

	let div = doc.createElement("div");

	div.innerHTML = htmlString;

	for (
		let elements = div.querySelectorAll("*"), i = elements.length - 1;
		i >= 0;
		i--
	) {
		let element = elements[i],
			tagName = element.localName;

		if (
			tagName == "script" ||
			tagName == "noscript" ||
			tagName == "noembed" ||
			!(element.attributes instanceof NamedNodeMap)
		) {
			try {
				element.parentNode.removeChild(element);
			} catch (e) {
				element.outerHTML = "";
			}

			continue;
		}

		if (!element.hasAttributes()) continue;

		for (
			let attributes = element.attributes, j = attributes.length - 1;
			j >= 0;
			j--
		) {
			let attribute = attributes[j],
				attributeName = attribute.localName,
				attributeValue = filterControlCharacters(attribute.value.trim());

			handleAttribute(element, attributeName, attributeValue);
		}
	}

	return div.innerHTML;
}

function handleAttribute(element, attributeName, attributeValue, tagName) {
	if (
		attributeName.startsWith("on") ||
		(["src", "href"].includes(attributeName) &&
			attributeValue.indexOf("javascript:") === 0) ||
		(["audio", "image", "img", "source", "video"].indexOf(tagName) === -1 &&
			["src", "data"].includes(attributeName) &&
			attributeValue.indexOf("data:") === 0)
	) {
		element.removeAttribute(attributeName);
	}
}

Vue.directive("html-safe", {
	// For Vue 2.x

	inserted: function (el, binding) {
		el.innerHTML = safeHTML(binding.value);
	},

	// For Vue 2.x

	update: function (el, binding) {
		if (binding.value !== binding.oldValue)
			el.innerHTML = safeHTML(binding.value);
	},

	unbind: function (el) {
		el.innerHTML = "";
	},
});

clearStore();
initTracking();

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
Vue.directive("closeArray", {
	bind(el, binding) {
		const { index, property, array, handler, exclude } = binding.value;

		const closeHandler = (event) => {
			// Build a selector string for exclusion elements
			const excludeSelector = exclude.map((item) => `.${item}`).join(", ");

			// Check if the click was outside the element and not on excluded elements
			if (
				!el.contains(event.target) &&
				!event.target.closest(excludeSelector)
			) {
				// Check if the index is valid within the array
				if (index >= 0 && index < array.length) {
					// Toggle the property value for the specified index
					array[index][property] = !array[index][property];
				}

				// Call the handler function with index as a parameter
				handler(index);
			}
		};

		el.__closableClickOutsideHandler = closeHandler;
		document.addEventListener("click", closeHandler);
	},
	unbind(el) {
		document.removeEventListener("click", el.__closableClickOutsideHandler);
		delete el.__closableClickOutsideHandler;
	},
});
let handleOutsideClick;
Vue.directive("closable", {
	bind(el, binding, vnode) {
		// Here's the click/touchstart handler
		// (it is registered below)
		handleOutsideClick = (e) => {
			e.stopPropagation();
			// Get the handler method name and the exclude array
			// from the object used in v-closable
			const { handler, exclude } = binding.value;
			// This variable indicates if the clicked element is excluded
			let clickedOnExcludedEl = false;
			exclude.forEach((refName) => {
				// We only run this code if we haven't detected
				// any excluded element yet
				if (!clickedOnExcludedEl) {
					let excludedEl = vnode.context.$refs[refName];
					excludedEl = excludedEl instanceof Vue ? excludedEl.$el : excludedEl;
					// Get the element using the reference name
					// See if this excluded element
					// is the same element the user just clicked on
					if (excludedEl) {
						// See if this excluded element
						// is the same element the user just clicked on
						clickedOnExcludedEl = excludedEl.contains(e.target);
					}
				}
			});
			// We check to see if the clicked element is not
			// the dialog element and not excluded
			if (!el.contains(e.target) && !clickedOnExcludedEl) {
				// If the clicked element is outside the dialog
				// and not the button, then call the outside-click handler
				// from the same component this directive is used in
				vnode.context[handler]();
			}
		};
		// Register click/touchstart event listeners on the whole page
		document.addEventListener("click", handleOutsideClick);
	},
	unbind() {
		// If the element that has v-closable is removed, then
		// unbind click/touchstart listeners from the whole page
		document.removeEventListener("click", handleOutsideClick);
	},
});
Vue.directive("closeArray", {
	bind(el, binding) {
		const { index, property, array, handler, exclude } = binding.value;

		const closeHandler = (event) => {
			if (
				!el.contains(event.target) &&
				event.target !== el &&
				!el.querySelector(exclude)?.contains(event.target)
			) {
				// Find the index dynamically if not provided in the template
				const dynamicIndex = array.findIndex((doc) => doc[property]);

				// Use the provided index or the dynamically found index
				const targetIndex = typeof index !== "undefined" ? index : dynamicIndex;

				if (targetIndex >= 0 && targetIndex < array.length) {
					array[targetIndex][property] = false;
				}

				if (typeof handler === "function") {
					handler(targetIndex);
				}
			}
		};

		el.__closableClickOutsideHandler = closeHandler;
		document.addEventListener("click", closeHandler);
	},
	unbind(el) {
		document.removeEventListener("click", el.__closableClickOutsideHandler);
		delete el.__closableClickOutsideHandler;
	},
});

// Filter for Questionbank Date created
Vue.prototype.$copyToClipboard = function (text) {
	console.log("Copying text to clipboard:", text);
	if (window.ShareCopyBridge && window.ShareCopyBridge.copy) {
		window.ShareCopyBridge.copy(text);
	} else if (navigator.clipboard) {
		navigator.clipboard.writeText(text);
	}
};
